module.exports = __webpack_public_path__ + "static/media/cooking-green.1cee6d96.png";